import { render, staticRenderFns } from "./ViewApellation.vue?vue&type=template&id=be8ab0a6"
import script from "./ViewApellation.vue?vue&type=script&lang=js"
export * from "./ViewApellation.vue?vue&type=script&lang=js"
import style0 from "./ViewApellation.vue?vue&type=style&index=0&id=be8ab0a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports